<template>
  <div>
    <div class="container-md">
      <div class="row">
        <div class="col-6">
          <h3 class="mb-5 text-uppercase">{{ itemgroup.title }}</h3>
        </div>
        <div class="col-6">
          <!-- <i class="float-right fa fa-plus " data-toggle="modal" data-target="#newItemgroup"
                        style="font-size: 24px;cursor: pointer" v-on:click="newCommittee"></i> -->
        </div>
      </div>
      <!-- COMMITTEES -->
      <div class="row" v-if="committees.length > 0">
        <div class="col-12">
          <div class="p-3 container-bg">
            <div class="row">
              <div class="col-12">
                <h3 class="text-uppercase">Commissies</h3>
              </div>
              <div
                v-for="(committee, index) in committees"
                :key="index"
                class="col-12 col-md-6"
              >
                <div class="card">
                  <div
                    class="p-2 pt-3 row no-gutters align-items-center"
                    style="border-radius: 20px"
                  >
                    <div class="col-md-3 col-12 text-sm-center">
                      <img
                        :src="
                          committee.profile_image
                            ? committee.profile_image
                            : '/assets/img/blank-profile-picture-973460_640.png'
                        "
                        style="width: 80px; height: 80px; 
                         border: 1px solid #ffffff;
                          border-radius: 50%;"
                        class="img-fluid"
                        alt=""
                      />
                    </div>
                    <div class="col-md-9 col-12">
                      <div class="px-2 card-block">
                        <h3
                          style="display: flex; justify-content: space-between"
                          class="text-white text-uppercase"
                        >
                          <span>{{ committee.title }}</span>
                          <!-- <a style="font-size:15px;color:white;" data-toggle="modal" data-dismiss="modal" href="#editCommittee"><i class="fas fa-edit"></i></a> -->
                        </h3>

                        <p
                          class="text-white"
                          style="line-height: normal; font-size: 12px"
                          v-html="reduceString(committee.description, 150)"
                        ></p>

                        <div :id="'showDescription' + index" class="modal">
                          <div class="modal-dialog">
                            <div class="modal-content modal-md committee-modal">
                              <div class="modal-body">
                                <p class="m-0">
                                  {{ committee.description }}
                                </p>
                                <div class="mt-3">
                                  <button
                                    data-dismiss="modal"
                                    class="btn btn-sm"
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          :data-target="'#showDescription' + index"
                          data-toggle="modal"
                          class="mt-2 text-white btn btn-small-mvn btn-sm btn-dark"
                        >
                          Lees meer
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- SUB-ITEMGROUPS -->
      <div class="row" v-if="itemgroup.children.length > 0">
        <div class="mt-3 col-12">
          <div class="p-3 container-bg">
            <h3 class="text-uppercase">Onderliggende groepen</h3>
            <div
              v-for="(child, index) in itemgroup.children"
              :key="index"
              class="p-2 flex-container flex-body"
            >
              <div class="item" style="flex: 0">
                <img
                  :src="child.image"
                  style="
                    height: 50px;
                    width: 50px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                  "
                  alt=""
                />
              </div>
              <div class="text-white item">
                <p style="margin: 0">{{ child.title }}</p>
              </div>
              <div class="item"></div>
              <div class="text-white item">
                <router-link
                  :to="'/itemgroups/' + child.id + '/' + child.title_slug"
                  class="btn btn-dark btn-sm"
                  >Open</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ITEMS -->
      <div class="row">
        <div class="mt-3 col-12">
          <div class="p-4 container-bg">
            <div class="row">
              <div class="col-12">
                <h3 class="text-uppercase">Items</h3>
              </div>
            </div>
            <div class="mt-4 row">
              <div class="col-md-6" v-if="itemtypes.length > 0">
                <div class="form-group" style="margin-left: 15px">
                  <select
                    v-model="filter_itemtype"
                    class="form-control"
                    id="exampleFormControlSelect1"
                    style="background-color: #292929; color: white"
                  >
                    <option value="0">-- Alles --</option>
                    <option
                      v-for="(type, index) in itemtypes"
                      :key="'type_' + index"
                      :value="type.id"
                    >
                      {{ type.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                v-if="filter_itemtype != 0 && userCanCreateItem"
                class="col-md-6 col-12"
                style="margin-left: -21px; margin-top: 5px"
              >
                <i
                  class="float-right mt-1 fa fa-plus"
                  data-toggle="modal"
                  data-target="#createItem"
                  style="font-size: 24px; cursor: pointer"
                ></i>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6 col-12" v-if="items.length">
                    <div>
                      <input
                        class="search-box"
                        v-model="filter_item_title"
                        type="text"
                        placeholder="Zoeken"
                      />
                      <button class="search-btn">
                        <img
                          src="/assets/img/search.svg"
                          alt="Search"
                          style="margin-bottom: 4px"
                        />
                      </button>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <button
                      v-if="items.length > 0"
                      @click="exportItems"
                      class="float-right btn btn-dark"
                    >
                      <span v-if="excel_loading">Downloading....</span>
                      <span v-else>
                        Export
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <router-link
              :to="'/items/' + item.id + '/' + item.title_slug"
              v-for="(item, index) in items_filtered"
              :key="'group_item_' + index"
              class="no-hover-decoration"
            >
              <div
                class="mt-3 flex-container flex-body"
                style="cursor: pointer"
              >
                <div class="pl-3 text-white item" style="flex: 2">
                  <i class="text-white fa fa-eye"></i>
                </div>

                <div class="text-left text-white item" style="flex: 10">
                  {{ item.title }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- CREATE ITEM MODAL -->
    <div>
      <div
        class="modal fade"
        id="createItem"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header" style="border-bottom: unset">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 pl-md-5 pr-md-5">
                  <div class="row">
                    <div class="mb-3 col-md-12">
                      <h5 class="text-uppercase">Maak item</h5>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="mt-3 ml-2 row">
                          <div class="col-lg-6">
                            <input
                              v-model="create_item.active"
                              id="activeevent"
                              class="mt-1 ml-1 form-check-input"
                              type="checkbox"
                              value=""
                            />
                            <label for="activeevent" class="ml-4">Actief</label>
                          </div>
                          <div class="col-lg-6">
                            <input
                              v-model="create_item.public"
                              id="publicevent"
                              class="mt-1 ml-1 form-check-input"
                              type="checkbox"
                              value=""
                            />
                            <label for="publicevent" class="ml-4"
                              >Publiek</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="name">Titel</label>
                        <input
                          v-model="create_item.title"
                          type="text"
                          class="form-control"
                          id="name"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="textarea1">Omschrijving</label>
                        <editor
                          id="textarea1"
                          v-model="create_item.description"
                          :init="{
                            height: 200,
                            menubar: false,
                            language: 'nl',
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code fullscreen',
                              'insertdatetime media table paste code help wordcount',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <button
                    @click="createItem()"
                    class="float-right mt-3 btn-dark"
                  >
                    Opslaan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CREATE ITEMGROUP MODAL -->
    <createItemgroup></createItemgroup>
  </div>
</template>

<script>
import mixins from "../../../mixins/index";
import createItemgroup from "../../settings/pages/itemgroups/create";
import axios from "axios";
export default {
  data() {
    return {
      itemgroup: {
        children: [],
      },
      create_item: {
        title: "",
        public: true,
        active: true,
        description: "",
        itemtype_id: null,
        itemgroup_id: null,
      },
      itemtypes: [],
      committees: [],
      items: [],
      items_filtered: [],
      title: "",
      filter_item_title: "",
      filter_itemtype: 0,
      userCanCreateItem: false,
      excel_loading: false,
    };
  },
  components: {
    createItemgroup,
  },
  mixins: [mixins],
  created() {
    this.$store
      .dispatch("get", "api/v1/itemgroups/" + this.$route.params.id)
      .then((data) => {
        console.log(data);
        this.itemgroup = data.data.data;
        this.itemtypes = data.data.data.itemtypes;
        if (
          Object.prototype.hasOwnProperty.call(this.itemgroup, "committees")
        ) {
          this.committees = this.itemgroup.committees;
        }

        this.items = data.data.data.items;
        let itemsSorted = this.items.sort(
          (a, b) => (a.title > b.title && 1) || -1
        );
        this.items_filtered = itemsSorted;
        this.$store.state.breadcrumbs = {
          title: "Informatie",
          links: [
            {
              title: "Informatie",
              href: "/itemgroups",
            },
            {
              title: this.$route.params.title,
              href: `/itemgroups/${this.$route.params.id}/${this.$route.params.title}`,
            },
          ],
        };
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    exportItems() {
      this.excel_loading = true;

      axios
        .post(
          process.env.VUE_APP_API_BASE_URL +
            "/api/v1/item/export?search=" +
            this.filter_item_title,
          {
            itemgroup_id: this.$route.params.id,
          },
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          this.excel_loading = false;

          const type = data.headers["content-type"];
          const blob = new File([data.data], { type: type });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = new Date().toDateString() + ".xlsx";
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.excel_loading = false;
        });
    },
    createItem() {
      this.create_item.itemtype_id = this.filter_itemtype;
      this.create_item.itemgroup_id = this.itemgroup.id;
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/items",
          details: this.create_item,
        })
        .then((data) => {
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    filter_items() {
      let filtered = this.items;

      if (this.filter_item_title != "") {
        filtered = this.items.filter((item) =>
          item.title
            .toLowerCase()
            .includes(this.filter_item_title.toLowerCase())
        );
      }

      if (this.filter_itemtype != 0) {
        filtered = filtered.filter(
          (item) => item.itemtype.id === this.filter_itemtype
        );
      }

      let itemsSorted = filtered.sort((a, b) => (a.title > b.title && 1) || -1);

      this.items_filtered = itemsSorted;
    },
  },
  watch: {
    // eslint-disable-next-line
    filter_item_title(value) {
      this.filter_items();
    },
    // eslint-disable-next-line
    filter_itemtype(value) {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/item/check-creation",
          details: {
            user_id: this.$store.state.auth.user.id,
            itemtype_id: value,
          },
        })
        .then((data) => {
          this.userCanCreateItem = data.data.data;
        })
        .catch(() => {
          this.saving = false;
        });
      this.filter_items();
    },
  },
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}
.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  padding: 0;
  border: unset;
}

.no-gutters {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}

.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}
.no-hover-decoration:hover {
  text-decoration: none;
}
</style>
